import React from "react";

import { Advertisement } from "@/common/Outro/Advertisement";
import { GlobalContextProps } from "@/contexts/GlobalContext";
import {
  InteractionLayout,
  InteractionOutro,
  OutroType,
} from "@/service/Model";

import { OutroOverlay } from "./index";
import { Outlink } from "./Outlink";
import { Question } from "./Question";
import { RegistrationForm } from "./RegistrationForm";

export function renderOutro(
  outro: InteractionOutro,
  context: { globals: GlobalContextProps },
  onClose: () => void,
  onSubmitEnd?: (status?: string) => void, // voting only
  hasScrollbar = false
): JSX.Element {
  const { globals } = context;
  const { interaction } = globals.response!;
  const lightLayout = interaction.layout === InteractionLayout.Light;

  let outroType: JSX.Element;

  switch (outro.outroType) {
    case OutroType.Advertising:
      outroType = <Advertisement outro={outro} />;
      break;
    case OutroType.Outlink:
      outroType = <Outlink outro={outro} onClose={onClose} />;
      break;
    case OutroType.RegistrationForm:
      outroType = (
        <RegistrationForm
          lightLayout={lightLayout}
          outro={outro}
          onClose={onClose}
          onSubmitEnd={onSubmitEnd}
        />
      );
      break;

    case OutroType.Request:
      outroType = <Question outro={outro} onClose={onClose} />;
      break;
    case OutroType.RequestOrAdvertising:
      //decision logic: https://as-wiki.axelspringer.de/pages/viewpage.action?pageId=241896322
      if (globals.tealiumConfig?.is_premium_user) {
        outroType = <Question outro={outro} onClose={onClose} />;
        break;
      } else {
        const randomizer = Math.floor(Math.random() * 100);
        if (randomizer < 61) {
          outroType = <Advertisement outro={outro} />;
          break;
        } else {
          outroType = <Question outro={outro} onClose={onClose} />;
          break;
        }
      }
    default:
      return <></>;
  }

  return (
    <OutroOverlay
      hasTopPadding={outro.outroType !== OutroType.RegistrationForm}
      onClose={onClose}
      lightLayout={lightLayout}
      hasScrollbar={hasScrollbar}
    >
      {outroType}
    </OutroOverlay>
  );
}
